import React from 'react';
import { RedocStandalone } from 'redoc';
// import { blue } from '@material-ui/core/colors';

const EventsApiComponent = () => (
  <div>
    <RedocStandalone
      specUrl={`${env.REACT_APP_EVENT_API.split('/api')[0]}/v2/api-docs`}
      // options={{ theme: { colors: { main: blue } } }}
    />
  </div>
);

export default EventsApiComponent;
